module.exports = __webpack_public_path__ + "img/8cf72bf278314e5e90a261324eec02ed.b84b8e6e.png";